import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FileUploadComponent } from '../../common/file-upload/file-upload.component';

@Component({
  selector: 'app-tco-file-upload-modal',
  standalone: true,
  imports: [FileUploadComponent, CommonModule, FormsModule],
  templateUrl: './tco-file-upload-modal.component.html',
  styleUrl: './tco-file-upload-modal.component.scss'
})
export class TcoFileUploadModalComponent {
@Input()
  configs: any = [];

  @Input()
  releases: any = [];

  activeModal = inject(NgbActiveModal);
  selectedRelease: any;
  isDisabled: boolean = true;
  selectedFile: any;
  isActive: boolean = false;

  constructor() {}
  
  ngOnInit() {
    this.selectedRelease = this.releases.length > 0 ? this.releases[0] : null;
    this.validateForm();
  }

  handleFilesSelected(event: any) {
    this.selectedFile = event?.files[0];
    this.validateForm();
  }

  validateForm() {
    this.isDisabled = !(this.selectedFile);
  }

  upload() {
    this.activeModal.close({
      value: {
        file: this.selectedFile,
      },
    });
  }
}
